/*eslint-disable*/
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/globals.css";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import i18n from "./I18n";
import { persistor, store } from "./store";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { APIProvider } from "@vis.gl/react-google-maps";
import { MAP_ID, MAP_KEY } from "@/configs/settings";
import { ThemeProvider } from "./ui/theme";
import { isLocalHost } from "./utils/utils";

// Suppress benign ResizeObserver error from Radix UI components
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    let active = true;
    super((entries, observer) => {
      requestAnimationFrame(() => {
        if (active) callback(entries, observer);
      });
    });
    const originalDisconnect = this.disconnect.bind(this);
    this.disconnect = () => {
      active = false;
      originalDisconnect();
    };
  }
};

// import { loadLocale } from "./i18n";

if (!isLocalHost()) {
  Sentry.init({
    dsn: "https://7e9ce347d04f4b22aa8f3680eeb27a86@o4504875636948992.ingest.sentry.io/4504875649662976",
    environment: "development",

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new BrowserTracing(),
      // new Sentry.Replay({
      //   // Additional SDK configuration goes in here, for example:
      //   maskAllText: false,
      //   blockAllMedia: false,
      // }),
    ],
  });
}

const mapLibraries = ["marker", "drawing"];
const mapIds = MAP_ID ? [MAP_ID] : undefined;

const AppContainer = () => {
  const [lang, setLang] = React.useState(i18n.defaultLocale);
  React.useEffect(() => {
    setLang(i18n.defaultLocale);
  }, [lang]);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <APIProvider
            apiKey={MAP_KEY}
            libraries={mapLibraries}
            mapIds={mapIds}
            version="3.64"
          >
            <App />
          </APIProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<AppContainer />);

// ReactDOM.render(<AppContainer />, document.getElementById('root'))
